import React, { useEffect, useRef } from "react";
import { useRightClick } from "../../context/RightClickContext";

type Props = {
  items: React.ReactNode;
  children: React.ReactNode;
  id?: string;
  context?: any;
  options?: Record<string, any>;
  onOpen?: () => void;
};

export default function RightClickMenu({
  items,
  children,
  id,
  context,
  options,
  onOpen,
}: Props) {
  const { openMenu, menu, updateMenu } = useRightClick();
  const triggerIdRef = useRef(id ?? `${Math.random().toString(36).slice(2, 9)}`);

  // if items change while menu is open for this trigger, update it
  useEffect(() => {
    if (menu.open && menu.triggerId === triggerIdRef.current) {
      updateMenu({ items });
    }
  }, [items, menu.open, menu.triggerId, updateMenu]);

  const handleContextMenu = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();

    // open the global menu for this trigger
    openMenu({
      x: e.clientX,
      y: e.clientY,
      items,
      context,
      options,
      triggerId: triggerIdRef.current,
    });

    if (onOpen) onOpen();
  };

  // wrap children with a neutral wrapper that sets a data attribute used by the provider
  return (
    <span
      style={{ display: "contents" }}
      data-rightclick-trigger
      data-rightclick-id={triggerIdRef.current}
      onContextMenu={handleContextMenu}
    >
      {children}
    </span>
  );
}
